/* unplugin-vue-components disabled */
const __default__ = {
  props: {
    active: {type: [String, Number], required: true},
    horizontal: {type: Boolean, default: false}
  },
  data(){
    return {
      leave: false,
      height: undefined,
      width: undefined,
      on_resize: $utils.timers.debounce(this.setHeight, 500)
    }
  },
  mounted(){
    if (this.horizontal) this.setHeight()
  },
  beforeUnmount(){
    this.on_resize.abort()
  },
  methods: {
    setHeight(el){
      const item = el || this.$refs.item
      if (!item) return
      const rect = item.getBoundingClientRect()
      if (this.horizontal) this.width = `${rect.width}px`
      else this.height = `${rect.height}px`
    },
    onBeforeLeave(){
      if (this.horizontal) {
        this.width = `${this.$el.getBoundingClientRect().width}px`
      }
      this.leave = true
    },
    onAfterEnter(){
      this.leave = false
    },
    onBeforeEnter(el){
      this.setHeight(el)
    },
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "9cc7479a-height": (_ctx.height),
  "9cc7479a-width": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__